export const onlyNumber = texto => {
  let numTarj = '';
  for (let i = 0; i < texto.length; i++) {
    switch (texto[i]) {
      case '0':
      case '1':
      case '2':
      case '3':
      case '4':
      case '5':
      case '6':
      case '7':
      case '8':
      case '9':
        {
          numTarj += texto[i];
        }
        break;
      default:
        break;
    }
  }
  return numTarj;
};
